import cloneDeep from 'lodash/cloneDeep';
import { ID } from '../../../../util/ID';

/**
 * @param Snap element - The SVG element to create the transform for.
 * @param {Object} [options] - The options {
     circleBackground - handlers color
     circleColor      -
     circleRadius     -
     circleBigRadius  -
     borderColor      -
     borderWidth      -
     borderDash       -
     handleLength     -
     handles          : {   - corner handlers
       scale - Scale handlers array (['tl' - *top left*, 'br' - *bottom right*, 'bl' - *bottom left*])
       remove: Remove handlers array (['tr' - *top right*])
     }
 * }
 */

const DEF = {
  circleBackground: '#5fa4ff',
  circleColor: '#000000',
  circleRadius: 7,
  circleBigRadius: 10,
  borderColor: '#5fa4ff',
  borderWidth: 1,
  borderDash: 3,
  handleLength: 30,
  phantomOpacity: 0.2,
  handleScale: ['tl', 'br'], //'bl',
  handleRemove: ['tr'],
  handleRotate: true,
  boundary: false,
  mask: false
};

export const Transform = class {
  option;

  El;
  boundary;
  boundaryUniqueId;
  mask;
  clone;
  borders;
  placeholder;
  placeholderEl;
  placeholderView;
  icons;

  attrs;
  bboxHandleDirection;

  handlesGroup;
  hidden;
  plugged;

  origGlobalMatrix;

  boundaryBB;

  attr;
  data;
  handle;
  prevattr;

  constructor(El, options: any = {}) {
    this.option = {
      maxSize: options.maxSize || null,
      circleBackground: options.circleBackground || DEF.circleBackground,
      circleColor: options.circleColor || DEF.circleColor,
      circleRadius: options.circleRadius || DEF.circleRadius,
      circleBigRadius: options.circleBigRadius || DEF.circleBigRadius,
      borderColor: options.borderColor || DEF.borderColor,
      borderWidth: options.borderWidth || DEF.borderWidth,
      borderDash: options.borderDash || DEF.borderDash,
      handleLength: options.handleLength || DEF.handleLength,
      phantomOpacity: options.phantomOpacity || DEF.phantomOpacity,
      handles: {
        scale: options.handles && options.handles.scale ? options.handles.scale : DEF.handleScale,
        remove:
          options.handleRemove === false
            ? false
            : Array.isArray(options.handleRemove)
            ? options.handleRemove
            : DEF.handleRemove,
        rotate: options.handleRotate != undefined ? options.handleRotate : DEF.handleRotate
      },
      onChange:
        options.onChange ||
        function () {
          /**/
        },
      remove:
        options.remove ||
        function () {
          /**/
        }
    };

    this.El = El;
    this.boundary = options.boundary || false;
    this.boundaryUniqueId = ID(3);
    this.mask = options.mask || false;
    this.clone = null;
    this.borders = null;
    this.placeholder = {};
    this.placeholderEl = null;
    this.placeholderView = null;
    this.icons = {
      scale: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 88 88'%3E%3Ccircle fill='%23${this.option.circleBackground.replace(
        '#',
        ''
      )}' cx='44' cy='44' r='44'/%3E%3C/svg%3E`,
      rotate: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 88 88'%3E%3Cg%3E%3Ccircle fill='%23${this.option.circleBackground.replace(
        '#',
        ''
      )}' cx='44' cy='44' r='44'/%3E%3Cpath fill='%23${this.option.circleColor.replace(
        '#',
        ''
      )}' d='M73.81,325.46H71.06a1.18,1.18,0,0,0-1.18,1.21l.23,9.77a24.58,24.58,0,1,0-4,31.84,1.19,1.19,0,0,0,.05-1.73l-2-2a1.19,1.19,0,0,0-1.63,0A19.43,19.43,0,1,1,67.34,342l-12.53-.3a1.19,1.19,0,0,0-1.22,1.19v2.74a1.19,1.19,0,0,0,1.19,1.19h19A1.19,1.19,0,0,0,75,345.67v-19a1.19,1.19,0,0,0-1.19-1.19Z' transform='translate(-6 -306)'/%3E%3C/g%3E%3C/svg%3E`,
      remove: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 88 88'%3E%3Ccircle fill='%23cc0000' cx='44' cy='44' r='44'/%3E%3Cpath fill='%23ffffff' d='M53.87,365.63h2.34a1.18,1.18,0,0,0,1.18-1.18V343.36a1.17,1.17,0,0,0-1.18-1.17H53.87a1.17,1.17,0,0,0-1.17,1.17v21.09A1.17,1.17,0,0,0,53.87,365.63Zm16-32.82h-8l-3.32-5.53a4.69,4.69,0,0,0-4-2.28H44.65a4.67,4.67,0,0,0-4,2.28l-3.32,5.53h-8a1.56,1.56,0,0,0-1.56,1.57v1.56a1.56,1.56,0,0,0,1.56,1.56h1.56v32.81A4.69,4.69,0,0,0,35.51,375H63.64a4.69,4.69,0,0,0,4.68-4.69h0V337.5h1.57a1.56,1.56,0,0,0,1.56-1.56v-1.56A1.56,1.56,0,0,0,69.89,332.81ZM44.48,330a.58.58,0,0,1,.5-.28h9.18a.61.61,0,0,1,.51.28l1.7,2.84H42.78Zm19.16,40.34H35.51V337.5H63.64Zm-20.71-4.68h2.35a1.18,1.18,0,0,0,1.17-1.18V343.36a1.17,1.17,0,0,0-1.17-1.17H42.93a1.17,1.17,0,0,0-1.17,1.17v21.09A1.18,1.18,0,0,0,42.93,365.63Z' transform='translate(-6 -306)'/%3E%3C/svg%3E`
    };
    this.attrs = null;
    this.bboxHandleDirection = [
      [-1, -1],
      [1, -1],
      [1, 1],
      [-1, 1],
      [0, -1],
      [1, 0],
      [0, 1],
      [-1, 0]
    ];
    this.handlesGroup = null;
    this.hidden = false;
    this.plugged = false;
  }

  /*
   **  - Public
   */

  plug() {
    this.El.transform('');

    this.origGlobalMatrix = this.El.transform().globalMatrix;

    this._setOpt();

    this._setClone();

    // Handles
    this._setHandles();

    // Drag element
    this._setDrag();

    this._setPlaceholder();

    if (this.mask) {
      this.setMask(this.mask);
    }

    if (this.boundary) {
      this.setBoundary(this.boundary);
    }

    if (this.El.Rotate) {
      this.rotate(this.El.Rotate);
      this._fixOffsetAfterRotate();
    }

    this._apply();

    this.plugged = true;
  }

  hide() {
    if (!this.plugged) return;
    this.El.attr({ opacity: 0 });
    this.handlesGroup.attr({ opacity: 0 });
    this.borders.attr({ opacity: 0 });
    this.hidden = true;
  }

  show() {
    if (!this.plugged) return;
    this.El.attr({ opacity: this.option.phantomOpacity });
    this.handlesGroup.attr({ opacity: 1 });
    this.borders.attr({ opacity: 1 });
    this.hidden = false;
  }

  destroy() {
    if (!this.plugged) return;
    this._destroyHandles();
    this._destroyBorder();
    this._destroyPlaceholder();
    this._destroyClone();
    this._destroyDrag();
    this.plugged = false;
  }

  getPosition() {
    if (!this.plugged) return null;

    const w = this.attrs.size.x * this.attrs.scale.x;
    const h = this.attrs.size.y * this.attrs.scale.y;
    // const x = this.attrs.center.x + this.attrs.translate.x - w / 2;
    // const y = this.attrs.center.y + this.attrs.translate.y - h / 2;

    const box = this._getBox(this.attrs);

    return {
      bbox: this.El.getBBox(),
      attributes: this.attrs,
      art: {
        x: box.x,
        y: box.y,
        w,
        h,
        a: this.attrs.rotate
      }
    };
  }

  setBoundary(elem: any = null) {
    if (elem) {
      this.boundary = elem;
      this.boundaryBB = elem.getBBox();
    } else {
      this.boundary = false;
      this.boundaryBB = null;
    }
  }
  destroyBoundary() {
    this.setBoundary();
  }

  setMask(elem: any = null) {
    const bBBox = elem ? elem.getBBox() : this.El.paper.getBBox();
    this.placeholderView
      .attr({ x: bBBox.x, y: bBBox.y, width: bBBox.width, height: bBBox.height })
      .attr('viewBox', `0 0 ${bBBox.width} ${bBBox.height} `);
    this.placeholderEl.attr({ x: this.El.attr('x') * 1 - bBBox.x, y: this.El.attr('y') * 1 - bBBox.y });
    this._setPlaceholderOpt();
  }
  destroyMask() {
    if (!this.placeholderEl) return;
    this.setMask();
  }

  centralize(axis = '') {
    const bBBox = this.mask ? this.mask.getBBox() : this.El.paper.getBBox();
    const elBox = this.El.getBBox();
    const offset = {
      x: bBBox.x + bBBox.width / 2 - (elBox.x + elBox.width / 2),
      y: bBBox.y + bBBox.height / 2 - (elBox.y + elBox.height / 2)
    };
    if (axis !== 'V') {
      this.attrs.translate.x = this.attrs.translate.x + offset.x;
    }
    if (axis !== 'H') {
      this.attrs.translate.y = this.attrs.translate.y + offset.y;
    }

    this.placeholder.translate = {
      x: this.attrs.translate.x,
      y: this.attrs.translate.y
    };
    this._apply();
    this._onChange();
  }

  rotate(deg) {
    this._setAttr({ rotate: deg });
  }

  isHidden() {
    return this.hidden;
  }

  /*
   **  - Apply, Check && updates
   */
  _apply() {
    const toTransform = this._attrsToTransform(this.attrs);

    // Placeholder
    this._updatePlaceholderAttrs();

    this.El.transform(toTransform);
    this.clone.transform(toTransform);
    if (this.placeholderEl) {
      this.placeholderEl.transform(this._attrsToTransform(this.placeholder));
    }

    // Handlers
    this._updateHandles();
    // Borders
    this._setBorder();
  }

  _updateHandles() {
    const corners = this._getCorners();

    this.handlesGroup.selectAll('image').forEach((handle, i) => {
      if (handle.data('type') != 'rotate') {
        const pos = handle.data('pos');
        let corner;
        switch (pos) {
          case 'tl':
            corner = corners[0];
            break;
          case 'tr':
            corner = corners[1];
            break;
          case 'br':
            corner = corners[2];
            break;
          default:
            corner = corners[3];
        }
        handle.attr({
          x: corner.x - (handle.data('type') != 'remove' ? this.option.circleRadius : this.option.circleBigRadius),
          y: corner.y - (handle.data('type') != 'remove' ? this.option.circleRadius : this.option.circleBigRadius)
          //transform: 'R' + this.attrs.rotate
        });
      } else {
        const radius = (this.attrs.size.y / 2) * this.attrs.scale.y;
        const rad = (window as any).Snap.rad(this.attrs.rotate - 90);
        const w = this.option.circleBigRadius * 2;
        const cx =
            this.attrs.center.x + this.attrs.translate.x + (radius + this.option.handleLength + w / 2) * Math.cos(rad),
          cy =
            this.attrs.center.y + this.attrs.translate.y + (radius + this.option.handleLength + w / 2) * Math.sin(rad);

        handle.attr({
          x: cx - w / 2,
          y: cy - w / 2
        });

        const end_x = this.attrs.center.x + this.attrs.translate.x + radius * Math.cos(rad),
          end_y = this.attrs.center.y + this.attrs.translate.y + radius * Math.sin(rad);

        this.handlesGroup.selectAll('path')[0].attr({
          path: [
            ['M', end_x, end_y],
            ['L', cx, cy]
          ]
        });
      }
    });
  }

  _onChange() {
    this.option.onChange(this.getPosition());
  }

  /*
   **  - Objects & attributes
   */
  _setOpt() {
    const bbox = this.El.getBBox();

    if (this.attrs) return this.attrs;

    const x = bbox.x;
    const y = bbox.y;
    const width = bbox.width;
    const height = bbox.height;

    this.attrs = {
      x: x,
      y: y,
      size: {
        x: width,
        y: height
      },
      center: {
        x: x + width / 2,
        y: y + height / 2
      },
      rotate: 0,
      scale: {
        x: 1,
        y: 1
      },
      translate: {
        x: 0,
        y: 0
      },
      ratio: 1
    };
  }

  _fixOffsetAfterRotate() {
    const box = this._getBox(this.attrs);

    this.attrs.translate.x = this.attrs.x - box.x;
    this.attrs.translate.y = this.attrs.y - box.y;
  }

  _setPlaceholderOpt() {
    const pbox = this.placeholderEl.getBBox();
    this.placeholder = {
      x: pbox.x,
      y: pbox.y,
      size: {
        x: pbox.width,
        y: pbox.height
      },
      center: {
        x: pbox.x + pbox.width / 2,
        y: pbox.y + pbox.height / 2
      },
      rotate: this.attrs.rotate,
      scale: {
        x: this.attrs.scale.x,
        y: this.attrs.scale.y
      },
      translate: {
        x: this.attrs.translate.x,
        y: this.attrs.translate.y
      },
      ratio: 1
    };
  }

  _setAttr(newattrs) {
    const curAttrs = this.attrs;

    this.attrs = {
      ...curAttrs,
      ...newattrs
    };

    this._setPlaceholderOpt();
    this._apply();
  }

  _setHandles() {
    this.handlesGroup = this.El.paper.g();

    // Remove Handlers
    if (this.option.handles.remove) {
      this.option.handles.remove.forEach((pos) => {
        const handle = this._handle('remove', pos).attr({ cursor: 'pointer' });
        this.handlesGroup.append(handle.click(this.option.remove));
      });
    }

    // Scale Handlers
    this.option.handles.scale.forEach((pos) => {
      const handler = this._handle('scale', pos);
      this.handlesGroup.append(
        handler.drag(
          this._scalemove.bind(handler, this),
          this._scalestart.bind(handler, this),
          this._scaleend.bind(handler, this)
        )
      );
    });

    // Rotate handler
    if (this.option.handles.rotate) {
      const rotateHandler = this._handle('rotate');
      this.handlesGroup
        .append(
          rotateHandler.drag(
            this._rotatemove.bind(rotateHandler, this),
            this._rotatestart.bind(rotateHandler, this),
            this._rotateend.bind(rotateHandler, this)
          )
        )
        .append(this._handle('line'));
    }
  }
  _destroyHandles() {
    this.handlesGroup.remove();
    this.handlesGroup = null;
  }

  _handle(type, pos = '') {
    const img = this.icons[type];

    const bb = this.El.getBBox();
    let cposX,
      cposY,
      cursor,
      dir = {};
    if (type == 'line') {
      return this.El.paper
        .path([
          ['M', bb.x + bb.width / 2, bb.y - this.option.handleLength],
          ['L', bb.x + bb.width / 2, bb.y]
        ])
        .attr({
          stroke: this.option.borderColor,
          strokeWidth: this.option.borderWidth,
          strokeDasharray: this.option.borderDash
        });
    }
    if (type == 'rotate') {
      const w = this.option.circleBigRadius * 2;
      cposX = bb.x + bb.width / 2 - w / 2;
      cposY = bb.y - w - this.option.handleLength;
      return this.El.paper.image(img, cposX, cposY, w, w).attr({ cursor: 'crosshair' }).data('type', type);
    }

    switch (pos) {
      case 'tl':
        cposX = bb.x;
        cposY = bb.y;
        cursor = 'nw-resize';
        dir = { x: this.bboxHandleDirection[0][0], y: this.bboxHandleDirection[0][1] };
        break;
      case 'tr':
        cposX = bb.x + bb.width;
        cposY = bb.y;
        cursor = 'sw-resize';
        dir = { x: this.bboxHandleDirection[1][0], y: this.bboxHandleDirection[1][1] };
        break;
      case 'br':
        cposX = bb.x + bb.width;
        cposY = bb.y + bb.height;
        cursor = 'nw-resize';
        dir = { x: this.bboxHandleDirection[2][0], y: this.bboxHandleDirection[2][1] };
        break;
      case 'bl':
        cposX = bb.x;
        cposY = bb.y + bb.height;
        cursor = 'sw-resize';
        dir = { x: this.bboxHandleDirection[3][0], y: this.bboxHandleDirection[3][1] };
        break;
      default:
        cposX = bb.x;
        cposY = bb.y;
        dir = { x: this.bboxHandleDirection[0][0], y: this.bboxHandleDirection[0][1] };
        cursor = 'pointer';
    }
    cursor = type == 'remove' ? 'pointer' : type == 'rotate' ? 'crosshair' : cursor;

    const w = type == 'scale' ? this.option.circleRadius * 2 : this.option.circleBigRadius * 2;

    const hand = this.El.paper
      .image(img, 0, 0, w, w)
      .attr({
        x: cposX - (type != 'remove' ? this.option.circleRadius : this.option.circleBigRadius),
        y: cposY - (type != 'remove' ? this.option.circleRadius : this.option.circleBigRadius)
      })
      .attr({ cursor: cursor })
      .data('pos', pos)
      .data('direction', JSON.stringify(dir))
      .data('type', type);
    return hand;
  }

  _setDrag() {
    this.El.attr({ cursor: 'grab' });
    this.El.drag(this._move.bind(this.El, this), this._start.bind(this.El, this), this._stop.bind(this.El, this));
  }
  _destroyDrag() {
    this.El.attr({ cursor: 'default' });
    this.El.undrag();
  }

  _setClone() {
    this.clone = this.El.paper.rect(this._rectObjFromBB(this.El.getBBox()));
    this.clone.attr({ opacity: 0 });
    this.El.before(this.clone);
    return this.clone;
  }
  _destroyClone() {
    this.clone.remove();
    this.clone = null;
  }

  _setPlaceholder() {
    const bBBox = this.El.paper.getBBox();
    const newObj = this.El.clone();
    this.placeholderView = this.El.paper
      .svg(bBBox.x, bBBox.y, bBBox.width, bBBox.height, 0, 0, bBBox.width, bBBox.height)
      .append(newObj);
    newObj.attr({ x: this.El.attr('x') * 1 - bBBox.x, y: this.El.attr('y') * 1 - bBBox.y });
    this.El.before(this.placeholderView);
    this.El.attr({ opacity: this.option.phantomOpacity });
    this.placeholderEl = newObj;
    this._setPlaceholderOpt();
  }
  _destroyPlaceholder() {
    this.placeholderEl.remove();
    this.placeholderEl = null;
    this.placeholderView.remove();
    this.placeholderView = null;
    this.El.attr({ opacity: 1 });
    this.placeholder = {};
  }
  _updatePlaceholderAttrs() {
    this.placeholder = {
      ...this.placeholder,
      ...{
        rotate: this.attrs.rotate,
        scale: {
          x: this.attrs.scale.x,
          y: this.attrs.scale.y
        },
        translate: {
          x: this.attrs.translate.x,
          y: this.attrs.translate.y
        }
      }
    };
  }

  _setBorder() {
    const opt = this.option;
    const strokeWidth = opt.borderWidth / this.El.transform().globalMatrix.split().scalex,
      strokeDash = opt.borderDash / this.El.transform().globalMatrix.split().scalex;

    const bbRect = this._rectObjFromBB(this.El.getBBox());
    const bbTRect = this._rectObjFromBB(this.El.getBBox(1));

    if (this.El.data('bbT') && this.El.data('bb')) {
      this.El.data('bbT')
        .attr(bbTRect)
        .attr({ strokeWidth: strokeWidth, strokeDasharray: strokeDash })
        .transform(this.El.transform().global.toString());
      this.El.data('bb').attr(bbRect);
      return;
    }

    const bbT = this.El.paper
      .rect(bbTRect)
      .attr({ fill: 'none', stroke: opt.borderColor, strokeWidth: strokeWidth, strokeDasharray: strokeDash })
      .transform(this.El.transform().global.toString());
    const bb = this.El.paper.rect(bbRect).attr({
      fill: 'none',
      stroke: opt.borderColor,
      strokeWidth: opt.borderWidth,
      strokeDasharray: opt.borderDash,
      opacity: 0.4,
      id: `boundaryBorder-${this.boundaryUniqueId}`
    });

    this.El.data('bbT', bbT);
    this.El.data('bb', bb);
    this.borders = this.El.paper.g(bbT, bb);
    this.El.parent().append(this.borders);
  }

  _destroyBorder() {
    this.El.data('bbT') && this.El.data('bbT').remove();
    this.El.data('bb') && this.El.data('bb').remove();
    this.El.data('bbT', null);
    this.El.data('bb', null);
    this.borders.remove();
    this.borders = null;
  }

  /*
   **  - Events Handlers
   */
  _move(self, dx, dy) {
    const previos = cloneDeep(self.attrs);

    self.attrs.translate.x = self.o.translate.x + dx;
    self.attrs.translate.y = self.o.translate.y + dy;

    self._boundaryOnHandler(previos);

    self._apply();
  }
  _start(self, x, y) {
    self.o = cloneDeep(self.attrs);
    this.attr({ cursor: 'grabbing' });
  }
  _stop(self) {
    self._boundaryEndHandler();
    self._onChange();
    this.attr({ cursor: 'grab' });
  }

  _scalemove(self, dx, dy, x, y) {
    let tdx = self._getTransformedDrag(self, this.data('op').x, this.data('op').y, x, y);
    let rx, ry;

    const previos = cloneDeep(self.attrs);

    const direction = JSON.parse(this.data('direction'));

    const sin = self.o.rotate.sin;
    const cos = self.o.rotate.cos;

    // First rotate dx, dy to element alignment.
    rx = tdx.x * cos - tdx.y * sin;
    ry = tdx.x * sin + tdx.y * cos;

    rx *= Math.abs(direction.x);
    ry *= Math.abs(direction.y);

    // And finally rotate back to canvas alignment.
    const rdx = rx * cos + ry * sin;
    const rdy = rx * -sin + ry * cos;

    self.attrs.translate = {
      x: self.o.translate.x + rdx / 2,
      y: self.o.translate.y + rdy / 2
    };

    // Mouse position, relative to element center after translation.
    const mx = self.o.handlePos.x + tdx.x - self.attrs.center.x - self.attrs.translate.x;
    const my = self.o.handlePos.y + tdx.y - self.attrs.center.y - self.attrs.translate.y;
    // Position rotated to align with element.
    rx = mx * cos - my * sin;
    ry = mx * sin + my * cos;

    // Maintain aspect ratio.
    const ratio = (self.attrs.size.x * self.attrs.scale.x) / (self.attrs.size.y * self.attrs.scale.y),
      tdy = rx * direction.x * (1 / ratio);
    tdx = ry * direction.y * ratio;

    if (tdx > tdy * ratio) {
      rx = tdx * direction.x;
    } else {
      ry = tdy * direction.y;
    }

    // Scale element so that handle is at mouse position
    const sx = (rx * 2 * direction.x) / self.o.size.x;
    const sy = (ry * 2 * direction.y) / self.o.size.y;

    self.attrs.scale = {
      x: +sx.toFixed(2) || self.attrs.scale.x,
      y: +sy.toFixed(2) || self.attrs.scale.y
    };

    // Maintain aspect ratio.
    const trans = {
      x: (self.attrs.scale.x - self.o.scale.x) * self.o.size.x * direction.x,
      y: (self.attrs.scale.y - self.o.scale.y) * self.o.size.y * direction.y
    };

    rx = trans.x * cos + trans.y * sin;
    ry = -trans.x * sin + trans.y * cos;

    self.attrs.translate.x = self.o.translate.x + rx.toFixed(2) / 2;
    self.attrs.translate.y = self.o.translate.y + ry.toFixed(2) / 2;

    self.attrs.ratio = self.attrs.scale.x / self.attrs.scale.y;

    if (self.attrs.scale.x <= 0 || self.attrs.scale.y <= 0) {
      self.attrs = previos;
      return;
    }

    // INFO prevent scale if size is over max values
    const artW = self.attrs.size.x * self.attrs.scale.x;
    const artH = self.attrs.size.y * self.attrs.scale.y;

    if (
      self.option.maxSize?.w && self.option.maxSize?.h &&
      (artW > self.option.maxSize.w || artH > self.option.maxSize.h)
    ) {
      self.attrs = previos;
      return;
    }

    self._boundaryOnHandler(previos);

    self._apply();
  }
  _scalestart(self, x, y) {
    this.data('op', self._getCursorPoint(x, y));

    const rotate = (window as any).Snap.rad((360 - self.attrs.rotate) % 360),
      handlePos = {
        x: parseInt(this.attr('x')),
        y: parseInt(this.attr('y'))
      };

    // Offset values.
    self.o = cloneDeep(self.attrs);

    self.o.handlePos = {
      x: handlePos.x + self.option.circleRadius,
      y: handlePos.y + self.option.circleRadius
    };

    // Pre-compute rotation sin & cos for efficiency.
    self.o.rotate = {
      sin: Math.sin(rotate),
      cos: Math.cos(rotate)
    };
  }
  _scaleend(self) {
    self._boundaryEndHandler();
    self._onChange();
  }

  _rotatemove(self, dx, dy, x, y) {
    const tdx = self._getTransformedDrag(self, this.data('op').x, this.data('op').y, x, y);
    const w = self.option.circleBigRadius * 2;
    const cx = tdx.x + this.handle.x + w / 2,
      cy = tdx.y + this.handle.y + w / 2;
    const rad = Math.atan2(cy - self.o.center.y - self.o.translate.y, cx - self.o.center.x - self.o.translate.x);

    const previos = cloneDeep(self.attrs);

    self.attrs.rotate = (window as any).Snap.deg(rad) + 90;

    self._boundaryOnHandler(previos);

    self._apply();
  }
  _rotatestart(self, x, y) {
    this.data('op', self._getCursorPoint(x, y));
    self.o = cloneDeep(self.attrs);
    this.handle = {
      x: parseInt(this.attr('x')),
      y: parseInt(this.attr('y'))
    };
  }
  _rotateend(self) {
    self._boundaryEndHandler();
    self._onChange();
  }

  _boundaryOnHandler(prevattrs) {
    if (!this._checkBoundary(this.attrs)) {
      if (!this.prevattr) {
        this.prevattr = prevattrs;
      }

      this.El.paper.select(`#boundaryBorder-${this.boundaryUniqueId}`).attr({ fill: 'rgba(255, 0, 0, 0.1)', stroke: '#c00' });
    } else {
      this.prevattr = false;
      this.El.paper.select(`#boundaryBorder-${this.boundaryUniqueId}`).attr({ fill: 'none', stroke: this.option.borderColor, opacity: 0.4 });
    }
  }

  _boundaryEndHandler() {
    if (this.prevattr) {
      this.attrs = cloneDeep(this.prevattr);
      this.prevattr = false;
      this.El.paper.select(`#boundaryBorder-${this.boundaryUniqueId}`).attr({ fill: 'none', stroke: this.option.borderColor, opacity: 0.4 });
      this._apply();
    }
  }

  _checkBoundary(attrs) {
    if (!this.boundaryBB) {
      return true;
    }

    const box = this.boundaryBB;
    const nextbb = this._getBox(attrs);

    return !(
      Math.ceil(nextbb.x) < box.x ||
      Math.ceil(nextbb.y) < box.y ||
      Math.floor(nextbb.x2) > box.x2 ||
      Math.floor(nextbb.y2) > box.y2
    );
  }

  /*
   **  - UTILS
   */
  _getCorners(attributes = null) {
    const $attrs = attributes || this.attrs;
    const rad = {
      x: (window as any).Snap.rad($attrs.rotate),
      y: (window as any).Snap.rad($attrs.rotate + 90)
    };

    const radius = {
      x: ($attrs.size.x / 2) * $attrs.scale.x,
      y: ($attrs.size.y / 2) * $attrs.scale.y
    };

    const corners = [],
      signs = [
        { x: -1, y: -1 },
        { x: 1, y: -1 },
        { x: 1, y: 1 },
        { x: -1, y: 1 }
      ];

    signs.map(function (sign) {
      corners.push({
        x:
          $attrs.center.x +
          $attrs.translate.x +
          sign.x * radius.x * Math.cos(rad.x) +
          sign.y * radius.y * Math.cos(rad.y),
        y:
          $attrs.center.y +
          $attrs.translate.y +
          sign.x * radius.x * Math.sin(rad.x) +
          sign.y * radius.y * Math.sin(rad.y)
      });
    });

    return corners;
  }

  _getBox(attrs) {
    const corners = this._getCorners(attrs);
    const box = {
      x: null,
      x2: null,
      y: null,
      y2: null
    };
    corners.forEach((c) => {
      box.x = box.x === null || c.x < box.x ? c.x : box.x;
      box.x2 = box.x2 === null || c.x > box.x2 ? c.x : box.x2;
      box.y = box.y === null || c.y < box.y ? c.y : box.y;
      box.y2 = box.y2 === null || c.y > box.y2 ? c.y : box.y2;
    });
    return box;
  }

  _rectObjFromBB(bb) {
    return { x: bb.x, y: bb.y, width: bb.width, height: bb.height };
  }

  _getTransformedDrag(self, otx, oty, x, y) {
    const xy = self._getCursorPoint(x, y);
    const tdx: any = {};
    const snapInvMatrix = self.origGlobalMatrix.invert();
    snapInvMatrix.e = snapInvMatrix.f = 0;
    tdx.x = snapInvMatrix.x(xy.x - otx, xy.y - oty);
    tdx.y = snapInvMatrix.y(xy.x - otx, xy.y - oty);
    return tdx;
  }

  _getCursorPoint(x, y) {
    const pt = this.El.paper.node.createSVGPoint();
    pt.x = x;
    pt.y = y;
    return pt.matrixTransform(this.El.paper.node.getScreenCTM().inverse());
  }

  _attrsToTransform(attrs) {
    return [
      't' + parseFloat(attrs.translate.x.toFixed(4)),
      parseFloat(attrs.translate.y.toFixed(4)),
      'r' + parseFloat(attrs.rotate.toFixed(4)),
      parseFloat(attrs.center.x.toFixed(4)),
      parseFloat(attrs.center.y.toFixed(4)),
      's' + parseFloat(attrs.scale.x.toFixed(4)),
      parseFloat(attrs.scale.y.toFixed(4)),
      parseFloat(attrs.center.x.toFixed(4)),
      parseFloat(attrs.center.y.toFixed(4))
    ].join();
  }
};
